<template>
  <loading-content
   :loading="loading"
   :error="error"
   :isTab="false">
    <v-form ref="form">

      <v-text-field
        outline
        v-model="form.name"
        :rules="readonly ? [] : required"
        :disabled="readonly"
        :background-color="readonly ? '#ccc' : ''"
        label="NOME/NAME"
      />

      <v-text-field
        outline
        v-model="form.relationship_details"
        :rules="readonly ? [] : required"
        :background-color="readonly ? '#ccc' : ''"
        :disabled="readonly"
        label="TIPO DE RELACIONAMENTO COM O ALUNO / RELATIONSHIP TO STUDENT"
      />

      <v-layout row wrap>
        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            v-model="form.mobile_phone"
            :rules="readonly ? [] : required"
            :background-color="readonly ? '#ccc' : ''"
            :disabled="readonly"
            label="TELEFONE CELULAR / MOBILE PHONE"
          />
        </v-flex>

        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            v-model="form.home_phone"
            :background-color="readonly ? '#ccc' : ''"
            :disabled="readonly"
            label="TELEFONE RESIDENCIAL / HOME PHONE"
          />
        </v-flex>
      </v-layout>
    </v-form>
  </loading-content>
</template>

<script>
import * as api from '@/api'
import { nestedRegistry, formTabs } from '@/mixins'
import LoadingContent from '@/components/LoadingContent'

/**
 * @group Form
 * Componente de form para contatos de emergencia
 */
export default {
  name: 'FormEmergencyContact',

  components: {
    LoadingContent
  },

  props: {
    emergency_contact_id: {
      type: Number,
      default: null
    },

    emergency_contact_attributes: {
      type: Object,
      default: () => ({})
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    required: [v => !!v || 'Campo obrigatório/Field is required']
  }),

  mixins: [nestedRegistry, formTabs],

  mounted () {
    if (!this.readonly) {
      let promise

      if (this.emergency_contact_id) {
        promise = api.emergencyContact.edit(this.currentStudentId, this.emergency_contact_id)
      } else {
        promise = api.emergencyContact.getModel(this.currentStudentId)
      }

      promise
        .then(this.handleResponse)
        .catch(this.handleError)
        .finally(this.handleFinally)
    } else {
      this.readonlyLoad(this.emergency_contact_attributes)
    }
  },

  methods: {
    /**
     * @vuese
     * Método para envio de dados da form
     */
    save () {
      if (this.validateForm()) {
        this.$emit('emergency_contact_attributes', this.form)
      }
    }
  },

  watch: {
    emergency_contact_attributes (newValue) {
      this.form = newValue
    }
  }
}
</script>
